import blueLogo from '../../../images/logoBlue.png';
import landscape from '../../../images/landscape.png';


function Transition1() {
  return (
    <div className="w-full flex flex-col items-center text-lg">
      <div className="absolute bg-gradient-to-r from-[#2d2f5b] to-[#31305c] w-full h-[10%] m10:h-[30%] z-0" />
      <div className="max-w-7xl w-full px-16 m6:px-5 z-10 m10:text-center">
        <div className="w-full flex flex-row m10:flex-col justify-center">
          <div className="flex-col w-full mr-[5%] m10:mr-0 bg-white rounded-3xl shadow-2xl p-10 m6:px-5 m10:rounded-b-none">
            <div className="flex flex-row m6:flex-col-reverse m6:items-center m10:justify-center i3:text-left i4:text-left m10:mb-7">
              <img src={blueLogo} alt="logo" className="h-28 m6:w-20 m6:h-auto px-5 m6:px-0 m6:mt-5" />
              <div className="flex flex-col justify-center pl-5 m6:pl-0">
                <p className="font-bold text-2xl">
                  Snow GMAO
                </p>
                <p className="mt-2">
                  Application de maintenance
                </p>
              </div>
            </div>
            <p className="font-bold text-xl mt-3">
              Un logiciel de maintenance personnalisable à souhait pour votre système d'enneigement, ni-plus, ni-moins.
            </p>
            <p className="mt-3">
              Grâce à l'avancée technologique de Snow GMAO, l'application est 100% personnalisable et s'adapte à vos besoins.
            </p>
          </div>
          <div className="flex-col w-full ml-[5%] m10:ml-0 bg-white rounded-3xl shadow-2xl m10:rounded-t-none">
            <img src={landscape} alt="landscape" className="w-full rounded-t-3xl m10:rounded-t-none" />
            <p className="px-10 py-7">
              Snow GMAO à été développé en collaboration avec les ingénieurs neiges du val d'isère
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Transition1;